import React from 'react';
import TitleField from '../../fields/TitleField';
import FlagsField from '../../fields/FlagsField';
import DescriptionField from '../../fields/DescriptionField';
import DeliveryTimeField from '../../fields/DeliveryTimeField';
import PriceField from '../../fields/PriceField';
import TagsField from '../../fields/TagsField';
import DisplayOptionsField from '../../fields/DisplayOptionsField';

import s from './FirstStep.scss';

interface Props {}

const FirstStep: React.FC<Props> = () => {
  return (
    <div className={s['root']}>
      <TitleField />
      <FlagsField />
      <DescriptionField />
      <PriceField />
      <DeliveryTimeField />
      <TagsField />
      <DisplayOptionsField />
    </div>
  );
};
FirstStep.displayName = 'FirstStep';

export default FirstStep;
